import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet";

import fi from "../assets/Fi.webp";
import p1 from "../assets/P1.png";
import p2 from "../assets/P2.png";
import p3 from "../assets/P3.png";
import p4 from "../assets/P4.png";
import BBBBB from "../assets/chooseR.webp";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";
import { useNavigate } from 'react-router-dom'; 
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";




const Finance = () => {
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };



      const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        const [isServicesOpen, setIsServicesOpen] = useState(false);
        const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
        const [isCompanyOpen, setIsCompanyOpen] = useState(false);
      
        const toggleMobileMenu = () => {
          setIsMobileMenuOpen(!isMobileMenuOpen);
        };
      
        const toggleServicesDropdown = () => {
          setIsServicesOpen(!isServicesOpen);
        };
      
        const toggleIndustriesDropdown = () => {
          setIsIndustriesOpen(!isIndustriesOpen);
        };
      
        const toggleCompanyDropdown = () => {
          setIsCompanyOpen(!isCompanyOpen);
        };
const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const features = [
  {
    number: "01",
    title: "Enhanced security",
    description:
      "Traditional FTP lacks encryption, but this solution secures every transfer with SFTP to prevent unauthorized access.",
    icon: p1,
    cardBg: "bg-[#FEEFE9]",
    textColor: "text-[#FF6A00]",
  },
  {
    number: "02",
    title: "Efficiency & automation",
    description:
      "The program automates file transfers end-to-end, reducing human error and boosting operational efficiency.",
    icon: p2,
    cardBg: "bg-[#E7EBFF]",
    textColor: "text-[#4C6FFF]",
  },
  {
    number: "03",
    title: "Streamlined operations",
    description:
      "Post-transfer cleanup minimizes duplication and risks, keeping the environment secure and tidy.",
    icon: p3,
    cardBg: "bg-[#F3E9FE]",
    textColor: "text-[#914DFF]",
  },
  {
    number: "04",
    title: "User friendly interface",
    description:
      "Lentera’s file mover enables secure transfers through a simple, user-friendly interface.",
    icon: p4,
    cardBg: "bg-[#E8FFF0]",
    textColor: "text-[#00B44B]",
  },
];


// Left Animation Controller
const leftControls = useAnimation();
const [leftRef, inViewLeft] = useInView({ threshold: 0.3 });

useEffect(() => {
  if (inViewLeft) {
    leftControls.start("show");
  } else {
    leftControls.start("hidden");
  }
}, [inViewLeft]);

// Right Animation Controller
const rightControls = useAnimation();
const [rightRef, inViewRight] = useInView({ threshold: 0.3 });

useEffect(() => {
  if (inViewRight) {
    rightControls.start("show");
  } else {
    rightControls.start("hidden");
  }
}, [inViewRight]);



const textControls = useAnimation();
  const cardsControls = useAnimation();

  const [textRef, textInView] = useInView({ triggerOnce: false, threshold: 0.3 });
  const [cardsRef, cardsInView] = useInView({ triggerOnce: false, threshold: 0.3 });

  useEffect(() => {
    if (textInView) {
      textControls.start("visible");
    } else {
      textControls.start("hidden");
    }
  }, [textInView, textControls]);

  useEffect(() => {
    if (cardsInView) {
      cardsControls.start("visible");
    } else {
      cardsControls.start("hidden");
    }
  }, [cardsInView, cardsControls]);

  const fadeInFromLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  const fadeInFromRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
 // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
   const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    <>
    <Helmet>
        <title>Financial Services & Secure File Transfers | LENTERA Finance Solutions.</title>
        <meta name="description" content="Improve security, automate operations, and streamline money management for individuals and businesses."/>
        <meta name="keywords" content="LENTERA finance services, money management solutions, financial planning support, streamlined financial operations.Education "/>
      </Helmet>
    <ToastContainer position="top-right" autoClose={3000} />
   <div className="w-full font-[Poppins]">
   
  

  


<section className="w-full bg-[#F9FFDD] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="text-[#212129] text-sm font-semibold uppercase mb-3 tracking-wide">
        Finance Service
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
        Brighten your financial <br className="hidden sm:block" /> future by today
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
        Take full control of your money with powerful financial tools,<br />
        personalized expert guidance, and bold, easy-to-use solutions — all <br />
        designed to help you make smarter decisions and start seeing results <br />
        today.      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      <img src={fi} alt="Finance Illustration"  className="w-full max-w-[500px] h-auto object-contain" />
      {/* <img
        src={WebDevelopmentImage}
        alt="Web Developer Illustration"
        className="w-full max-w-[500px] h-auto object-contain"
      /> */}
    </motion.div>

  </div>
</section>


<section className="font-poppins bg-white py-16 px-4 md:px-8 lg:px-16 overflow-x-hidden">
  {/* Overview Heading and Description */}
  <div className="text-center max-w-4xl mx-auto mb-12">
    <h2 className="text-[36px] weight-[600] md:text-[42px] lg:text-[48px] font-semibold text-[#1A1A1A] leading-tight mb-4">
      Overview
    </h2>
    <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
      Secure file transfers protect sensitive data, making it crucial to switch from FTP to the safer SFTP protocol. <br className="hidden md:block" />
      Lentera’s FTP to SFTP File Mover speeds up and secures this transition.
    </p>
  </div>

  {/* Content Box */}
  <div className="bg-[#F3EFFF] rounded-[60px] px-8 py-12 md:px-12 lg:px-16 max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center justify-between relative overflow-hidden">
    
    {/* Left Text */}
    <div className="w-full lg:w-6/12 text-left">
      <h3 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] mb-6 leading-snug">
        What is financials <br /> services?
      </h3>
      <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
        Financial services cover businesses that manage money, including banks, real estate, investments, and insurance. They offer services like banking, investing, insurance, and financial planning. Their purpose is to help individuals and organizations manage finances effectively.
      </p>
    </div>

    {/* Right Image */}
    <div className="w-full lg:w-6/12 flex justify-center mb-8 lg:mb-0">
      <img
        src={require("../assets/FF.webp")} // ✅ Replace with your actual image path
        alt="Finance Illustration"
        className="max-w-[480px] w-full h-auto object-contain"
      />
    </div>
  </div>
</section>




  <section className="bg-[#1c1c1c] text-white py-20 px-4 sm:px-6 md:px-10 lg:px-20">
  {/* Heading */}
  <div className="flex flex-col lg:flex-row justify-between items-start gap-8 mb-16">
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-snug">
      Benefits of Financial <br className="hidden md:block" /> Services
    </h2>
    <p className="text-base text-[#E1E1E1] max-w-xl">
      Financial services provide essential support for managing money, enabling
      individuals and businesses to save, invest, borrow, and plan for a secure
      financial future.
    </p>
  </div>

  {/* Cards */}
  <div className="flex flex-wrap justify-center gap-6">
    {features.map((item, index) => (
      <motion.div
        key={index}
        custom={index}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        variants={cardVariants}
        className="relative bg-white rounded-[28px] p-4 max-w-[310px] w-full min-h-[292.82px] flex-shrink-0"
      >
        {/* Top Icon */}
        <div className="absolute -top-6 left-1/2 -translate-x-1/2">
          <img src={item.icon} alt={`icon ${item.number}`} className="w-10 h-10" />
        </div>

        {/* Card Content */}
        <div className={`mt-8 ${item.cardBg} p-4 rounded-[20px]`}>
          <h4 className={`text-[18px] font-semibold mb-1 ${item.textColor}`}>
            {item.number}
          </h4>
          <h3 className="text-[#1c1c1c] text-[16px] font-semibold mb-2">
            {item.title}
          </h3>
          <p className="text-[#3d3d3d] text-sm leading-relaxed">
            {item.description}
          </p>
        </div>
      </motion.div>
    ))}
  </div>
</section>


<section className="bg-white font-poppins py-16 px-4 md:px-12 lg:px-20 overflow-x-hidden">
  {/* Heading */}
  <div className="text-center max-w-4xl mx-auto mb-12">
    <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
      Why choose us
    </h2>
    <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
      Discover what sets us apart — unmatched expertise, innovation, <br className="hidden sm:inline-block" />
      and results.
    </p>
  </div>

  {/* Main Content */}
  <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start gap-10 lg:gap-20">

    {/* Left Grouped Image */}
    <div className="w-full lg:w-6/12">
      <div className="bg-[#F3EFFF] rounded-[40px] px-6 py-10 h-full">
        <img
          src={require("../assets/II.webp")} // replace with actual left image (illustration)
          alt="Why Choose Illustration"
          className="w-full h-auto object-contain"
        />
      </div>
    </div>

    {/* Right Grouped Cards Image */}
   <div className="w-full lg:w-6/12 flex justify-center">
  <img
    src={BBBBB}
    alt="Why Choose Features"
    className="w-full h-auto object-contain"
  />
</div>
  
  </div>
</section>


     {/* <div
      style={{
        width: '100%',
        padding: isMobile ? '40px 20px' : '80px 60px',
        boxSizing: 'border-box',
        backgroundColor: '#f8f8f8',
        textAlign: isMobile ? 'center' : 'left',
        display: 'flex',
        flexDirection: 'column',
        alignItems: isMobile ? 'center' : 'flex-start',
      }}
    >
      <h1
        style={{
          fontSize: isMobile ? '2rem' : '2.7rem',
          fontWeight: '600',
          lineHeight: 1.2,
          color: '#1a1a1a',
          marginBottom: '20px',
          maxWidth: '600px',
        }}
      >
        Smarter solutions for <br /> financial services
      </h1>
      <p
        style={{
          fontSize: '0.9rem',
          color: '#444',
          maxWidth: '600px',
          marginBottom: '30px',
        }}
      >
        We deliver innovative tools that enhance security, streamline <br/>operations,
        and drive growth across the financial sector.
      </p>
     <div
  style={{
    display: 'flex',
    justifyContent: isMobile ? 'center' : 'flex-start',
    gap: '16px',
  }}
>
  <img
    src={r1}
    alt="Previous"
    style={{
    width: '40px',
      height: '40px',
      borderRadius: '50%',
      border: '1px solid #e0e0e0',
      backgroundColor: '#fff',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      padding: '12px', // optional, adds inner spacing
      objectFit: 'contain',
    }}
  />
  <img
    src={r2}
    alt="Next"
    style={{
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      border: '1px solid #e0e0e0',
      backgroundColor: '#fff',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      padding: '12px',
      objectFit: 'contain',
    }}
  />
</div>


    </div> */}


    <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    </div>
    </>
  )
}

export default Finance